
import { Prop, Vue } from "vue-property-decorator";

export default class UiSelectDecor extends Vue {
  @Prop({ type: String, default: "text" }) nameSelect: string;
  @Prop({ type: String, default: "green" }) color: string;
  @Prop({ type: Boolean, default: true }) showArrow: boolean;
}
